module.exports = __webpack_public_path__ + "img/undraw_work_chat_re_qes4.09ac9723.svg";